// Footer.js
import React, { useEffect } from "react";
import logo2 from "../../assets/logo2.png";
import { ImTwitter } from "react-icons/im";
import { PiInstagramLogoFill } from "react-icons/pi";
import { FaFacebookF, FaLinkedin } from "react-icons/fa";
import { motion, useAnimation } from "framer-motion";

const footerVariants = {
  hidden: { opacity: 0, y: 40 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.7, ease: "easeOut" } },
};

const itemVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: (i) => ({
    opacity: 1,
    y: 0,
    transition: { delay: i * 0.15, duration: 0.5 },
  }),
};

const Footer = () => {
  const controls = useAnimation();

  useEffect(() => {
    controls.start("visible");
  }, [controls]);

  return (
    <>
      <motion.footer
        className="w-full border-t border-gray-200 px-4 py-10 flex flex-col md:flex-row"
        style={{ fontFamily: "Gilroy-Medium" }}
        variants={footerVariants}
        initial="hidden"
        animate={controls}
      >
        <motion.div
          className="w-full md:w-2/5 md:px-20 mb-6 md:mb-0 flex flex-col items-center md:items-start"
          variants={itemVariants}
          custom={0}
        >
          <h3 className="mb-2 font-medium">
            <img src={logo2} alt="inggage" className="w-24" />
          </h3>
          <p className="text-black text-sm leading-6 font-medium text-center md:text-left">
            AI-powered influencer marketing platform
          </p>
        </motion.div>

        <div className="w-full md:w-3/5 flex flex-col md:flex-row mt-0">
          <motion.div
            className="flex-1 flex flex-col ml-0 md:ml-3 mb-6 md:mb-0 items-center md:items-start"
            variants={itemVariants}
            custom={1}
          >
            <h4 className="mb-2 font-medium">Information</h4>
            <ul className="list-none p-0">
              {["FAQ", "Blog", "Support", "Help"].map((item, i) => (
                <motion.li
                  key={item}
                  className="text-black text-sm font-light mb-2 hover:underline cursor-pointer text-start md:text-left"
                  variants={itemVariants}
                  custom={i + 2}
                >
                  {item}
                </motion.li>
              ))}
            </ul>
          </motion.div>
          <motion.div
            className="flex-1 flex flex-col ml-0 md:ml-3 mb-6 md:mb-0 items-center md:items-start"
            variants={itemVariants}
            custom={2}
          >
            <h4 className="mb-2 font-medium">Company</h4>
            <ul className="list-none p-0">
              {["About us", "Careers", "Contact us", "Features"].map((item, i) => (
                <motion.li
                  key={item}
                  className="text-black text-sm font-light mb-2 hover:underline cursor-pointer text-start md:text-left"
                  variants={itemVariants}
                  custom={i + 6}
                >
                  {item}
                </motion.li>
              ))}
            </ul>
          </motion.div>
          <motion.div
            className="flex-1 flex flex-col ml-0 md:ml-3 items-center md:items-start"
            variants={itemVariants}
            custom={3}
          >
            <h4 className="mb-2 font-medium">Follow Us</h4>
            <div className="flex gap-3 mb-3 h-7 justify-center md:justify-start">
              <motion.a
                href="https://www.instagram.com/inggage/"
                target="_blank"
                rel="noopener noreferrer"
                whileHover={{ scale: 1.15, rotate: -8 }}
                className="transition-transform"
                variants={itemVariants}
                custom={10}
              >
                <PiInstagramLogoFill className="text-black text-xl hover:text-pink-600" />
              </motion.a>
              <motion.a
                href="https://www.instagram.com/inggage/"
                target="_blank"
                rel="noopener noreferrer"
                whileHover={{ scale: 1.15, rotate: 8 }}
                className="transition-transform"
                variants={itemVariants}
                custom={11}
              >
                <FaFacebookF className="text-black text-xl hover:text-blue-600" />
              </motion.a>
              <motion.a
                href="https://www.instagram.com/inggage/"
                target="_blank"
                rel="noopener noreferrer"
                whileHover={{ scale: 1.15, rotate: -8 }}
                className="transition-transform"
                variants={itemVariants}
                custom={12}
              >
                <ImTwitter className="text-black text-xl hover:text-sky-500" />
              </motion.a>
              <motion.a
                href="https://www.linkedin.com/company/inggage/"
                target="_blank"
                rel="noopener noreferrer"
                whileHover={{ scale: 1.15, rotate: 8 }}
                className="transition-transform"
                variants={itemVariants}
                custom={13}
              >
                <FaLinkedin className="text-black text-xl hover:text-blue-700" />
              </motion.a>
            </div>
          </motion.div>
        </div>
      </motion.footer>

      <motion.div
        className="bg-black text-white py-2 flex justify-center items-center"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.7, duration: 0.6 }}
        style={{fontFamily:"Gilroy-Medium"}}
      >
        <p className="text-white text-sm font-medium text-center">
          © 2025 Inggage. All rights reserved.
        </p>
      </motion.div>
    </>
  );
};

export default Footer;
